// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + ".css?v=" + {"personal-index":"9b876836","personal-profile":"fade88f5","personal-discount":"9b876836","personal-order-list":"9b876836","personal-order":"9b876836","personal-error-boundary":"aad0d2e0","personal-wishlist":"9b876836","toastify":"201cb3df"}[chunkId] + "";
};